import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { IEventsItem } from '@project/store/EventsOpen/types';
import { GeoJSONFeatureCollection } from 'ol/format/GeoJSON';

export interface Photo {
  id: number;
  description: string;
  photo: string;
}

export interface MunicipalDistrict {
  id: number;
  title: string;
  all_culture_id: number | null;
}

export interface EventsResponseProps {
  id: number;
  title: string;
  description: string;
  price: number;
  age: number;
  is_checked: boolean;
  sale_link: string;
  is_archived: boolean;
  author: string;
  organizer: string;
  photos: Photo[];
  date_start: string;
  date_end: string;
  municipal_district: number | null;
  user_id: number;
  geom: GeoJSON.Point | null;
}

export type EventsGeoJSONPropertiesResponse = Omit<
  EventsResponseProps,
  'geom' | 'id'
>;

export type EventsResponse = GeoJSON.Feature<
  GeoJSON.Point,
  EventsGeoJSONPropertiesResponse
> & {
  id: number;
};

export class EventsMunicipalDistricts {
  readonly url = 'api/open-events-districts/?_page_size=0&_order=title';

  constructor(private _axios: AxiosInstance) {}

  get = async (): Promise<MunicipalDistrict[]> => {
    const response = await this._axios.get<MunicipalDistrict>(`${this.url}`);

    // @ts-ignore
    return response.data.results;
  };
}

export class EventsPhotos {
  readonly url = 'api/open-events-files';

  constructor(private _axios: AxiosInstance) {}

  async post(events: EventsResponseProps, response_id: number) {
    let formData = new FormData();

    if (events.photos.hasOwnProperty('fileList')) {
      // @ts-ignore
      for (const file of Object.keys(events.photos.fileList)) {
        // @ts-ignore
        if (events.photos.fileList[file].name === '') {
          continue;
        }
        // @ts-ignore
        formData.set('photo', events.photos.fileList[file].originFileObj);
        await this._axios.post(
          process.env.BACKEND_URL + `/${this.url}/` + response_id + '/',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        );
      }
    }
  }

  async delete(events: EventsResponseProps) {
    if (events.photos.hasOwnProperty('removedFiles')) {
      // @ts-ignore
      for (const removedId of Object.keys(events.photos.removedFiles)) {
        await this._axios.delete(
          // @ts-ignore
          process.env.BACKEND_URL +
            `/${this.url}/` +
            // @ts-ignore
            // TODO:
            events.photos.removedFiles[removedId] +
            '/',
        );
      }
    }
  }
}

export class EventsGeoJSONLayer {
  readonly url = 'api/open-events';

  constructor(private _axios: AxiosInstance) {}

  async get(
    config?: AxiosRequestConfig,
  ): Promise<{ type: 'FeatureCollection'; features: IEventsItem[] }> {
    const response = await this._axios.get<GeoJSONFeatureCollection>(
      `${this.url}/`,
      config,
    );

    // @ts-ignore
    return response.data;
  }
}

export class EventsApi {
  readonly url = 'api/open-events';

  constructor(private _axios: AxiosInstance) {}

  async get(params?: URLSearchParams | string, signal?: AbortSignal) {
    const response = await this._axios.get<EventsResponse>(`${this.url}/`, {
      params,
      signal,
    });

    // @ts-ignore
    return response.data;
  }

  async create(Events: Partial<EventsResponse>): Promise<EventsResponse> {
    const response = await this._axios.post<EventsResponse>(`${this.url}/`, {
      ...Events,
    });

    // @ts-ignore
    return response.data;
  }

  async delete(id: number): Promise<EventsResponse> {
    const response = await this._axios.delete<EventsResponse>(
      `${this.url}/${id}`,
    );

    // @ts-ignore
    return response.data.results;
  }

  async patch(
    value: Partial<Omit<EventsResponse, 'geom'>> & {
      id: number;
      geom?: string;
    },
  ): Promise<EventsResponse> {
    const response = await this._axios.patch<EventsResponse>(
      `${this.url}/${value.id}/`,
      { ...value },
    );

    // @ts-ignore
    return response.data;
  }
}
